import { useSyncExternalStore } from 'react';
import { Button } from '@/components/ui/button';
import { updateWatcher } from '../lib/serviceWorkerUpdate';

/**
 * A small bar that appears when a newer version of the app has been installed. It never reloads the page by itself,
 * so nobody loses text they are typing: the person presses Reload when they are ready.
 */
export function UpdateAvailableBar() {
  const updateReady = useSyncExternalStore(updateWatcher.subscribe, updateWatcher.getSnapshot, () => false);
  if (!updateReady) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed bottom-20 left-1/2 z-[60] flex w-[calc(100%-2rem)] max-w-md -translate-x-1/2 items-center justify-between gap-3 rounded-lg border border-border bg-card px-4 py-2.5 shadow-lg md:bottom-4"
    >
      <span className="font-body text-sm text-foreground">A new version is available.</span>
      <Button size="sm" onClick={() => window.location.reload()}>Reload</Button>
    </div>
  );
}
